import Image from 'next/image'
import { FC, useState } from 'react'
import { IDiamond } from 'types/diamond.types'
import ArrowDownSVG from './ArrowDownSVG.svg'
import ArrowUpSVG from './ArrowUpSVG.svg'
import { formatPercent } from '@utils/format-percent'
import Link from 'next/link'
import { Button } from '@components/ui'
import { saveSeenDiamond } from '@utils/seen-diamond'

interface Props {
  diamond: IDiamond
}

const DiamondAdditionalDetails: FC<Props> = ({ diamond }) => {
  const [showAdditionalDetails, setShowAdditionalDetails] = useState(false)

  const handleMeasurements = () => {
    return `${diamond?.measure1} x ${diamond?.measure2} x ${diamond?.measure3} mm`
  }

  return (
    <div className="flex flex-col gap-3 lg:flex-row lg:flex-1 lg:items-center lg:gap-0 md:w-auto md:pl-0">
      <div className="flex flex-col gap-2 md:gap-3">
        <h2 className="whitespace-nowrap text-xs font-semibold md:font-normal md:text-xl leading-8 text-nowrap">
          {diamond?.weight} Carat {diamond?.shape}{' '}
          {diamond?.labcreated == true ? 'Lab' : 'Natural'} Diamond
        </h2>
        <ul className="text-base font-normal leading-8 text-gray-dark flex flex-col gap-2 md:gap-0">
          <li className="hidden md:block md:text-base md:leading-7">
            <span className="font-semibold md:font-normal text-primary md:text-gray-dark">
              Carat:
            </span>{' '}
            {diamond?.weight}
          </li>
          <li className="text-xs md:text-base md:leading-7">
            <span className="font-semibold md:font-normal text-primary md:text-gray-dark">
              Cut:
            </span>{' '}
            {diamond?.cut}
          </li>
          <li className="text-xs md:text-base md:leading-7">
            <span className="font-semibold md:font-normal text-primary md:text-gray-dark">
              Color:
            </span>{' '}
            {diamond?.color}
          </li>
          <li className="text-xs md:text-base md:leading-7">
            <span className="font-semibold md:font-normal text-primary md:text-gray-dark">
              Clarity:
            </span>{' '}
            {diamond?.clarity}
          </li>

          {/* collapse menu Additional Details */}
          <li className="hidden md:flex flex-row items-center">
            <button
              id="additional-details"
              className="cursor-pointer"
              onClick={() => setShowAdditionalDetails(!showAdditionalDetails)}
              aria-label="Show additional details"
            >
              <span className="mr-2">Additional Details</span>
              {showAdditionalDetails && (
                <Image src={ArrowUpSVG} width={12} height={8} alt="arrowUp" />
              )}
              {!showAdditionalDetails && (
                <Image src={ArrowDownSVG} width={12} height={8} alt="arrowUp" />
              )}
            </button>
          </li>
          {showAdditionalDetails && (
            <>
              <li>Polish: {diamond?.polish}</li>
              <li>Symmetry: {diamond?.symmetry}</li>
              <li>
                {diamond?.depth && `Depth: ${formatPercent(diamond?.depth, 1)}`}
              </li>
              <li>
                {diamond?.tablep &&
                  `Table: ${formatPercent(diamond?.tablep, 1)}`}
              </li>
              <li>
                {diamond.measure1 && diamond?.measure2 && diamond?.measure3 && (
                  <p>Measurements: {handleMeasurements()}</p>
                )}
              </li>
            </>
          )}
        </ul>
      </div>
      <div className="w-full lg:inline-flex lg:justify-end mt-2 md:mt-0">
        <Link href={`/diamond/${diamond.id}`} passHref>
          <Button
            Component="a"
            variant="type1"
            className="w-40"
            onClick={() => saveSeenDiamond(diamond.id)}
          >
            <span className="font-normal text-xs md:text-base">
              View Diamond
            </span>
          </Button>
        </Link>
      </div>
    </div>
  )
}

export default DiamondAdditionalDetails
